export default __webpack_public_path__ + "static/media/game.5b77f74a.mp4";